(function () {
  function initReviewsSliders() {
    document.querySelectorAll('.reviews__splide').forEach(function (el) {
      var section = el.closest('.reviews');

      var splide = new Splide(el, {
        type: 'slide',
        perPage: 3,
        perMove: 1,
        gap: '1.5rem',
        padding: { right: '5rem' },
        arrows: false,
        pagination: true,
        breakpoints: {
          1024: {
            perPage: 2,
            padding: { right: '4rem' },
          },
          640: {
            perPage: 1,
            gap: '1rem',
            padding: { right: '3.5rem' },
          },
        },
      });

      var prevBtn = section && section.querySelector('.reviews__btn--prev');
      var nextBtn = section && section.querySelector('.reviews__btn--next');

      function syncButtons() {
        var index = splide.index;
        var end = splide.Components.Controller.getEnd();
        if (prevBtn) prevBtn.disabled = index === 0;
        if (nextBtn) nextBtn.disabled = index === end;
      }

      splide.on('mounted move', syncButtons);

      splide.mount();

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          splide.go('<');
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          splide.go('>');
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReviewsSliders);
  } else {
    initReviewsSliders();
  }
})();
